import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CardDisplayType, CardRequestType, CardScreen, CustomCardCategory } from '@ktypes/enums';
import { CardCollection } from '@ktypes/models';

const DISPLAYED_TAKE_ACTION_CARDS = 6;

@Component({
  selector: 'kp-take-action',
  templateUrl: './take-action.component.html',
  styleUrls: ['./take-action.component.scss'],
})
export class TakeActionComponent implements OnChanges {
  @Input() cardCollections: CardCollection[];
  // screen used for setting the url on loading the detail view
  @Input() cardScreen = CardScreen.today;
  @Input() isChallenge = false;
  @Input() isEmbedded = false;
  @Input() isLoading = false;

  cardDisplayType = CardDisplayType;
  cardRequestType = CardRequestType;
  customCardCategory = CustomCardCategory.takeAction;
  noCards = false;
  showViewAll: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.cardCollections != null) {
      this.showViewAll =
        this.isEmbedded &&
        this.cardCollections?.reduce(
          (totalCards, collections) => totalCards + Object.keys(collections?.cardItems || {})?.length,
          0
        ) > DISPLAYED_TAKE_ACTION_CARDS;
      let numFocusCards = 0;
      let numOtherCards = 0;
      this.cardCollections = this.cardCollections?.map((cardCollection) => {
        if (this.cardCollections.indexOf(cardCollection) === 0) {
          if (this.showViewAll) {
            // Filter Focus cards
            cardCollection.cardItems = Object.fromEntries(
              Object.entries(cardCollection?.cardItems || {}).slice(0, DISPLAYED_TAKE_ACTION_CARDS)
            );
          }
          numFocusCards = Object.keys(cardCollection?.cardItems || {})?.length;
        } else {
          numOtherCards = DISPLAYED_TAKE_ACTION_CARDS - numFocusCards;
          if (this.showViewAll) {
            // Filter other tracked cards
            cardCollection.cardItems = Object.fromEntries(
              Object.entries(cardCollection?.cardItems || {}).slice(0, numOtherCards)
            );
            if (numOtherCards !== Object.keys(cardCollection?.cardItems || {})?.length) {
              numOtherCards = Object.keys(cardCollection?.cardItems || {})?.length;
            }
          }
        }
        return cardCollection;
      });

      this.noCards =
        this.cardCollections?.reduce(
          (totalCards, collections) => totalCards + Object.keys(collections?.cardItems || {})?.length,
          0
        ) === 0;
    }
  }
}
